const ADD_PICKUP_CONSTANTS = {
  ADD_PICKUP_PERSON: 'ADD_PICKUP_PERSON',
  SET_PICKUP_PERSON_ERROR_MSG: 'SET_PICKUP_PERSON_ERROR_MSG',
  SHOW_SUCCESS_MSG: 'SHOW_SUCCESS_MSG',
  SHOW_LOADER: 'SHOW_LOADER',
  HIDE_LOADER: 'HIDE_LOADER',
  SHOW_ERROR_MSG: 'SHOW_ERROR_MSG',
  RESET_STATE: 'RESET_STATE',
  OPEN_FORM: 'OPEN_FORM',
  SET_MODAL_DATA: 'SET_MODAL_DATA',
  RESET_ORDER_PAGINATION: 'RESET_ORDER_PAGINATION',
};

export default ADD_PICKUP_CONSTANTS;
